import { ContentfulMultiColumnEntry } from '@jbhi-fi/apis/src/contentful/types';
import { ButtonTransformer } from './ButtonTransformer';
import { MultiColumnEntryProps } from '../../MultiColumnEntry/MultiColumnEntry';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';
import React from 'react';
import { AssetTransformer } from './AssetTransformer';
import { RichText } from '../../RichText';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { GoToLink } from '../../GoToLink/GoToLink';

export abstract class MultiColumnEntryTransformer {
  static toMultiColumnEntryProps = (entry: ContentfulMultiColumnEntry): Omit<MultiColumnEntryProps, 'alignment'> => {
    const isButtonLinkType = entry.fields?.button?.fields?.type === 'Link';

    let transformedButton = undefined;
    if (entry.fields?.button) {
      transformedButton = isButtonLinkType ? (
        <GoToLink {...ButtonTransformer.toGoToLinkProps(entry.fields.button)} />
      ) : (
        <Button {...ButtonTransformer.toLanyardButtonProps(entry.fields.button)} />
      );
    }

    return {
      heading: entry.fields?.heading ?? '',
      headingSize: entry.fields?.headingSize ?? 'Medium',
      subText: entry.fields?.subText ? <RichText document={entry.fields.subText} /> : null,
      image: (
        <ContentfulImage isProgressive={false} {...AssetTransformer.toContentfulImageProps(entry?.fields?.image)} />
      ),
      imageSize: entry.fields?.imageSize ?? 'Full',
      button: transformedButton,
    };
  };
}
